var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErdefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 20,
    rx: 10,
    width: 20,
    x: 1,
    y: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 20,
    rx: 10,
    stroke: "#fff",
    width: 20,
    x: 1,
    y: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.155 12.884v1.794c0 .05-.04.09-.09.09H7.239a.09.09 0 0 1-.059-.158l3.905-3.411a.447.447 0 0 0-.002-.675l-3.9-3.367A.09.09 0 0 1 7.24 7h6.826c.05 0 .09.04.09.09v1.322",
    stroke: "#b9a2ff",
    strokeLinecap: "square",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErdefault);
export default __webpack_public_path__ + "static/media/er.default.5203f422a6db64d7b6d57d45ae4f9fd4.svg";
export { ForwardRef as ReactComponent };